(function () {
  var SIZE_PRIORITY = { medium: 0, large: 1, family: 2, sides: 3, default: 9 };
  var catalogByGroup = null;
  var catalogPromise = null;
  var injecting = {};
  var activeSizeByGroup = {};

  var GRID_SELECTOR = '#product-grid, ul.product-grid, collection-category.product-grid';
  var DEFAULT_CATALOG_COLLECTION = 'full-menu';
  var cartUpdateBound = false;
  var docObserverTimer = null;

  function getGrids(root) {
    root = root || document;
    return Array.prototype.slice.call(root.querySelectorAll(GRID_SELECTOR));
  }

  function getGridForElement(el) {
    if (!el) return null;
    return el.closest('#product-grid, ul.product-grid, collection-category.product-grid');
  }

  function usePanelMode(grid) {
    if (!grid) return true;
    if (grid.dataset.sizePanelMode === 'off') return false;
    if (grid.dataset.cardLayout === 'related') return false;
    if (grid.classList.contains('related-products__grid')) return false;
    if (grid.closest && grid.closest('.loved-meals-slider')) return false;
    if (grid.closest && grid.closest('.related-products') && !grid.classList.contains('mm-collection-grid')) {
      return false;
    }
    return true;
  }

  function unwrapPanelHost(host) {
    if (!host || !host.classList.contains('collection-size-host')) return host;

    var activePanel =
      host.querySelector('.collection-size-panel.is-active') || host.querySelector('.collection-size-panel');
    if (!activePanel) return host;

    var card = activePanel.querySelector('marmeto-product-card');
    host.innerHTML = '';
    if (card) host.appendChild(card);
    host.classList.remove('collection-size-host');
    return host;
  }

  function syncHostMetadata(host) {
    if (!host) return host;

    var card = host.querySelector('marmeto-product-card[data-handle-group^="handle_"]');
    if (!card) return host;

    host.setAttribute('data-handle-group', card.getAttribute('data-handle-group'));
    host.setAttribute('data-size', card.getAttribute('data-size') || host.getAttribute('data-size') || 'medium');
    return host;
  }

  function getHostGroup(host) {
    host = syncHostMetadata(host);
    if (!host) return '';
    var group = host.getAttribute('data-handle-group');
    return isHandleTaggedGroup(group) ? group : '';
  }

  function resolveHost(swatch) {
    if (!swatch) return null;

    var host = swatch.closest('.grid__item');
    if (host) return syncHostMetadata(host);

    var card = swatch.closest('marmeto-product-card[data-handle-group^="handle_"]');
    if (!card) return null;

    host = card.closest('.grid__item');
    if (host) return syncHostMetadata(host);

    return null;
  }

  function getCatalogCollectionHandle() {
    var path = window.location.pathname || '';
    var match = path.match(/\/collections\/([^/]+)/);
    if (match) return decodeURIComponent(match[1]);
    return DEFAULT_CATALOG_COLLECTION;
  }

  function escapeAttr(value) {
    if (window.CSS && typeof CSS.escape === 'function') return CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  }

  function isHandleTaggedGroup(group) {
    return !!group && group.indexOf('handle_') === 0;
  }

  function sizeFromTags(tags) {
    if (!Array.isArray(tags)) return '';
    for (var i = 0; i < tags.length; i++) {
      var tag = String(tags[i] || '').toLowerCase();
      if (tag.indexOf('size_') === 0) return tag.replace('size_', '');
    }
    return '';
  }

  function sizeFromHandle(handle) {
    var h = String(handle || '').toLowerCase();
    if (h.indexOf('size_medium') !== -1 || h.indexOf('-medium') !== -1 || h.indexOf('_medium') !== -1) {
      return 'medium';
    }
    if (h.indexOf('size_large') !== -1 || h.indexOf('-large') !== -1 || h.indexOf('_large') !== -1) {
      return 'large';
    }
    return '';
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) return tags;
    if (typeof tags === 'string') {
      return tags
        .split(',')
        .map(function (tag) {
          return tag.trim();
        })
        .filter(Boolean);
    }
    return [];
  }

  function normalizeGroupKey(group) {
    return String(group || '')
      .toLowerCase()
      .replace(/[^a-z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function handleGroupFromTags(tags) {
    if (!Array.isArray(tags)) return '';
    for (var i = 0; i < tags.length; i++) {
      var tag = String(tags[i] || '').toLowerCase();
      if (tag.indexOf('handle_') === 0) {
        // Match Liquid `tag | handleize` — keep hyphens, do not convert to underscores.
        return normalizeGroupKey(tag);
      }
    }
    return '';
  }

  function productHasAvailableVariant(product) {
    var variants = product && product.variants;
    if (!Array.isArray(variants) || !variants.length) return false;
    return variants.some(function (variant) {
      return variant && variant.available !== false;
    });
  }

  function catalogEntriesForGroup(group) {
    if (!catalogByGroup || !group) return [];
    var key = normalizeGroupKey(group);
    return catalogByGroup[key] || catalogByGroup[group] || [];
  }

  function activeSizesFromEntries(entries) {
    return uniqueSizes(
      (entries || []).map(function (entry) {
        return entry && entry.size;
      })
    );
  }

  /** Prefer catalog of available products; fall back to the currently visible size only. */
  function sizesForGroup(group, host) {
    var catalogSizes = activeSizesFromEntries(catalogEntriesForGroup(group));
    if (catalogSizes.length) return catalogSizes;

    var fallback = [];
    if (host) {
      fallback.push(
        host.getAttribute('data-active-size') ||
          host.getAttribute('data-size') ||
          (host.querySelector &&
            host.querySelector('.collection-size-panel.is-active') &&
            host.querySelector('.collection-size-panel.is-active').getAttribute('data-size'))
      );
    }
    return uniqueSizes(fallback);
  }

  function resolveGroup(product) {
    var tags = normalizeTags(product.tags);
    var group = handleGroupFromTags(tags);
    if (!group) return null;

    var size = sizeFromTags(tags) || sizeFromHandle(product.handle);
    if (size !== 'medium' && size !== 'large') return null;

    return { group: group, size: size, handle: product.handle, id: product.id };
  }

  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    var handle = getCatalogCollectionHandle();
    if (!handle) {
      catalogByGroup = {};
      catalogPromise = Promise.resolve(catalogByGroup);
      return catalogPromise;
    }

    catalogPromise = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var map = {};
        (data.products || []).forEach(function (product) {
          // Only published / purchasable sibling sizes should appear as swatches
          if (!productHasAvailableVariant(product)) return;

          var resolved = resolveGroup(product);
          if (!resolved) return;
          var key = normalizeGroupKey(resolved.group);
          if (!map[key]) map[key] = [];
          map[key].push({
            size: resolved.size,
            handle: resolved.handle,
            id: resolved.id,
            available: true,
          });
        });
        catalogByGroup = map;
        return map;
      })
      .catch(function () {
        catalogByGroup = {};
        return catalogByGroup;
      });

    return catalogPromise;
  }

  function getHost(grid, group) {
    if (!isHandleTaggedGroup(group)) return null;
    return grid.querySelector(
      ':scope > .grid__item.collection-size-host[data-handle-group="' + escapeAttr(group) + '"]'
    );
  }

  function getLooseGroupItems(grid, group) {
    if (!isHandleTaggedGroup(group)) return [];
    return Array.prototype.slice
      .call(grid.querySelectorAll(':scope > .grid__item'))
      .map(function (item) {
        return syncHostMetadata(item);
      })
      .filter(function (item) {
        return (
          item.getAttribute('data-handle-group') === group && !item.classList.contains('collection-size-host')
        );
      });
  }

  function getHandleTaggedGroups(grid) {
    var groups = {};
    Array.prototype.slice
      .call(grid.querySelectorAll(':scope > .grid__item'))
      .forEach(function (item) {
        syncHostMetadata(item);
        var group = item.getAttribute('data-handle-group');
        if (isHandleTaggedGroup(group)) groups[group] = true;
      });
    return Object.keys(groups);
  }

  function stripStraySizeUi(grid, items) {
    if (!grid) return;
    var scope = items;
    if (!scope) {
      scope = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid__item'));
    }
    scope.forEach(function (item) {
      syncHostMetadata(item);
      if (isHandleTaggedGroup(item.getAttribute('data-handle-group'))) return;
      item.querySelectorAll('.product-card__variants--size').forEach(function (node) {
        node.remove();
      });
    });
  }

  function uniqueSizes(values) {
    var seen = {};
    var sizes = [];
    values.forEach(function (size) {
      if (!size || seen[size]) return;
      seen[size] = true;
      sizes.push(size);
    });
    sizes.sort(function (a, b) {
      return (SIZE_PRIORITY[a] != null ? SIZE_PRIORITY[a] : 9) - (SIZE_PRIORITY[b] != null ? SIZE_PRIORITY[b] : 9);
    });
    return sizes;
  }

  function labelForSize(size, productType) {
    if ((productType || '').toLowerCase() === 'bundle') return 'Meal Pack';
    if (!size) return '';
    return size.charAt(0).toUpperCase() + size.slice(1);
  }

  function getCardProductType(host) {
    if (!host) return '';
    var card =
      host.matches && host.matches('marmeto-product-card')
        ? host
        : host.querySelector &&
          (host.querySelector('.collection-size-panel.is-active marmeto-product-card') ||
            host.querySelector('marmeto-product-card'));
    if (!card) return '';
    return (
      card.getAttribute('data-product-type') ||
      card.querySelector('cre-product-form')?.getAttribute('data-product-type') ||
      ''
    ).toLowerCase();
  }

  function getOrCreatePanels(host) {
    var panels = host.querySelector(':scope > .collection-size-panels');
    if (panels) return panels;

    panels = document.createElement('div');
    panels.className = 'collection-size-panels';

    var size = host.getAttribute('data-size') || 'default';
    var panel = document.createElement('div');
    panel.className = 'collection-size-panel is-active';
    panel.setAttribute('data-size', size);

    while (host.firstChild) {
      panel.appendChild(host.firstChild);
    }

    panels.appendChild(panel);
    host.appendChild(panels);
    host.classList.add('collection-size-host');
    return panels;
  }

  function findPanel(host, size) {
    return host.querySelector('.collection-size-panel[data-size="' + escapeAttr(size) + '"]');
  }

  function moveItemIntoHost(host, item) {
    if (!host || !item || host === item) return;

    var size = item.getAttribute('data-size') || 'default';
    var panels = getOrCreatePanels(host);
    if (findPanel(host, size)) {
      item.remove();
      return;
    }

    var panel = document.createElement('div');
    panel.className = 'collection-size-panel';
    panel.setAttribute('data-size', size);
    panel.hidden = true;

    while (item.firstChild) {
      panel.appendChild(item.firstChild);
    }

    panels.appendChild(panel);
    item.remove();
  }

  function ensureHostForGroup(grid, group) {
    if (!isHandleTaggedGroup(group)) return null;

    var host = getHost(grid, group);
    var looseItems = getLooseGroupItems(grid, group);

    if (!host) {
      if (!looseItems.length) return null;

      looseItems.sort(function (a, b) {
        var aSize = a.getAttribute('data-size') || '';
        var bSize = b.getAttribute('data-size') || '';
        return (SIZE_PRIORITY[aSize] != null ? SIZE_PRIORITY[aSize] : 9) -
          (SIZE_PRIORITY[bSize] != null ? SIZE_PRIORITY[bSize] : 9);
      });

      host = looseItems[0];
      getOrCreatePanels(host);
      looseItems.slice(1).forEach(function (item) {
        moveItemIntoHost(host, item);
      });
      return host;
    }

    looseItems.forEach(function (item) {
      moveItemIntoHost(host, item);
    });
    return host;
  }

  function buildSwatchWrap(sizes, activeSize, groupEntries, productType) {
    var wrap = document.createElement('div');
    wrap.className = 'product-card__variants product-card__variants--swatches product-card__variants--size no-js-hidden';

    var list = document.createElement('div');
    list.className = 'product-card__variant-swatches';
    list.setAttribute('role', 'list');
    list.style.setProperty('--swatch-columns', String(sizes.length));

    sizes.forEach(function (size) {
      var entry = (groupEntries || []).find(function (row) {
        return row.size === size;
      });
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-card__variant-swatch js-collection-size-swatch';
      if (size === activeSize) btn.classList.add('is-active');
      btn.setAttribute('data-size', size);
      if (entry && entry.handle) btn.setAttribute('data-product-handle', entry.handle);
      btn.setAttribute('role', 'listitem');
      btn.setAttribute('aria-pressed', size === activeSize ? 'true' : 'false');
      btn.textContent = labelForSize(size, productType);
      list.appendChild(btn);
    });

    wrap.appendChild(list);
    return wrap;
  }

  function getActivePanelInfo(host) {
    if (!host) return null;

    if (host.classList.contains('collection-size-host')) {
      var activePanel = host.querySelector('.collection-size-panel.is-active');
      if (activePanel) {
        var activeCard = activePanel.querySelector('marmeto-product-card');
        if (activeCard) return activeCard.querySelector('.product-card__info');
      }

      var panelCard = host.querySelector('marmeto-product-card');
      return panelCard ? panelCard.querySelector('.product-card__info') : null;
    }

    var card = host.querySelector('marmeto-product-card');
    return card ? card.querySelector('.product-card__info') : null;
  }

  function getSwatchScope(host) {
    return getActivePanelInfo(host) || host;
  }

  function removeHostLevelSwatches(host) {
    host.querySelectorAll(':scope > .collection-size-swatches').forEach(function (node) {
      node.remove();
    });
  }

  function removeAllSizeSwatches(host) {
    if (!host) return;
    removeHostLevelSwatches(host);
    host.querySelectorAll('.product-card__variants--size').forEach(function (node) {
      node.remove();
    });
  }

  function syncSwatchActiveState(host, activeSize) {
    var scope = getSwatchScope(host);
    if (!scope) return;

    scope.querySelectorAll('.js-collection-size-swatch').forEach(function (btn) {
      var isActive = btn.getAttribute('data-size') === activeSize;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function ensureSwatches(host, sizes, activeSize, groupEntries) {
    if (!host) return;
    if (!isHandleTaggedGroup(host.getAttribute('data-handle-group'))) return;

    var grid = getGridForElement(host);
    var panelMode = usePanelMode(grid);

    if (panelMode) {
      if (!host.classList.contains('collection-size-host')) {
        getOrCreatePanels(host);
      }

      removeHostLevelSwatches(host);

      host.querySelectorAll('.collection-size-panel:not(.is-active) .product-card__variants--size').forEach(function (node) {
        node.remove();
      });
    } else {
      removeHostLevelSwatches(host);
    }

    if (!sizes.length) {
      removeAllSizeSwatches(host);
      return;
    }

    var info = getActivePanelInfo(host);
    if (!info) return;

    var productType = getCardProductType(host);

    var existing = info.querySelector('.product-card__variants--size');
    if (existing) {
      var existingSizes = Array.prototype.slice
        .call(existing.querySelectorAll('.js-collection-size-swatch[data-size]'))
        .map(function (btn) {
          return btn.getAttribute('data-size');
        });
      var sizesMatch =
        existingSizes.length === sizes.length &&
        sizes.every(function (size) {
          return existingSizes.indexOf(size) !== -1;
        });

      if (sizesMatch) {
        var list = existing.querySelector('.product-card__variant-swatches');
        if (list) list.style.setProperty('--swatch-columns', String(sizes.length));
        existing.querySelectorAll('.js-collection-size-swatch[data-size]').forEach(function (btn) {
          btn.textContent = labelForSize(btn.getAttribute('data-size'), productType);
        });
        syncSwatchActiveState(host, activeSize);
        return;
      }

      existing.remove();
    }

    host.querySelectorAll('.product-card__variants--size').forEach(function (node) {
      node.remove();
    });

    var titleWrap = info.querySelector('.product-title-with-gram');
    var wrap = buildSwatchWrap(sizes, activeSize, groupEntries, productType);
    if (titleWrap) titleWrap.after(wrap);
    else info.insertBefore(wrap, info.firstChild);
  }

  function getCardFromHost(host) {
    if (!host) return null;
    host = unwrapPanelHost(syncHostMetadata(host));
    return host.querySelector('marmeto-product-card');
  }

  function setCardCartControlsLoading(host, isLoading) {
    if (!host) return;

    host = unwrapPanelHost(syncHostMetadata(host));
    var card = host.querySelector('marmeto-product-card');
    if (!card) return;

    var slot = card.querySelector('.mm-card__atc-slot') || card.querySelector('.price-and-add-to-cart');
    if (!slot) return;

    if (isLoading) {
      slot.classList.add('is-variant-switching');
      slot.setAttribute('aria-busy', 'true');

      slot.querySelectorAll('.cre-atc-btn, .qty-btn').forEach(function (btn) {
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        btn.classList.add('is-switching-disabled');
        btn.setAttribute('disabled', '');
        btn.setAttribute('aria-disabled', 'true');
      });
      return;
    }

    slot.classList.remove('is-variant-switching');
    slot.removeAttribute('aria-busy');

    slot.querySelectorAll('.is-switching-disabled').forEach(function (btn) {
      btn.classList.remove('is-switching-disabled');
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
    });

    if (window.syncCartControlVisibility) {
      window.syncCartControlVisibility(card);
    } else if (window.reinitializeCreCartControls) {
      window.reinitializeCreCartControls(card);
    }
  }

  function applyGroupVisibility(grid, group, size) {
    if (!isHandleTaggedGroup(group)) return Promise.resolve();

    var host = ensureHostForGroup(grid, group);
    if (!host) return Promise.resolve();

    var catalogEntries = catalogEntriesForGroup(group);
    // Only available product sizes — do not invent Medium/Large from empty panels
    var sizes = sizesForGroup(group, host);

    if (!sizes.length) return Promise.resolve();
    if (sizes.indexOf(size) === -1) size = sizes[0];

    activeSizeByGroup[group] = size;
    host.setAttribute('data-active-size', size);
    host.setAttribute('data-size', size);
    host.querySelectorAll('.collection-size-panel').forEach(function (panel) {
      var panelSize = panel.getAttribute('data-size');
      if (sizes.indexOf(panelSize) === -1) {
        panel.classList.remove('is-active');
        panel.hidden = true;
        return;
      }
      var isActive = panelSize === size;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    ensureSwatches(host, sizes, size, catalogEntries);

    var refreshPromise = ensurePanelCardContent(grid, host, group, size);

    return Promise.resolve(refreshPromise).then(function () {
      var activePanel = host.querySelector('.collection-size-panel.is-active');
      if (!activePanel || activePanel.hidden) {
        activePanel = host.querySelector('.collection-size-panel[data-size="' + escapeAttr(size) + '"]');
      }

      var activeCard = activePanel && activePanel.querySelector('marmeto-product-card');
      if (activeCard) {
        if (window.syncCartControlVisibility) {
          window.syncCartControlVisibility(activeCard);
        } else if (window.reinitializeCreCartControls) {
          window.reinitializeCreCartControls(activeCard);
        }
      }
    });
  }

  function getGridCardLayout(grid, host) {
    if (grid && grid.dataset.cardLayout) return grid.dataset.cardLayout;
    if (grid && grid.classList.contains('mm-collection-grid')) return 'collection';
    if (
      grid &&
      (grid.classList.contains('related-products__grid') ||
        (grid.closest && (grid.closest('.loved-meals-slider') || grid.closest('.related-products'))))
    ) {
      return 'related';
    }

    if (!host && grid) {
      host = grid.querySelector(':scope > .grid__item.collection-size-host[data-handle-group^="handle_"]');
    }

    var panel =
      host &&
      (host.querySelector('.collection-size-panel.is-active') || host.querySelector('.collection-size-panel'));
    if (panel) {
      if (panel.querySelector('.mm-card__nutrition') || panel.querySelector('.product-card__desc')) return 'collection';
      if (panel.querySelector('.product-card__footer')) return 'related';
    }

    return 'default';
  }

  function getGridItemView(grid, host) {
    var layout = getGridCardLayout(grid, host);
    if (layout === 'related') return 'grid-item-related';
    if (layout === 'default') return 'grid-item-default';
    return 'grid-item';
  }

  function shouldSwapCard(card, entry, size) {
    if (!card || !entry) return true;
    var currentHandle = card.getAttribute('data-product-handle') || '';
    var currentSize = card.getAttribute('data-size') || '';
    return currentHandle !== entry.handle || currentSize !== size;
  }

  function formatCardMoney(price) {
    var cents =
      typeof price === 'string'
        ? Math.round(parseFloat(price) * 100)
        : Math.round(Number(price) || 0);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getVariantGram(variant) {
    if (!variant) return '';
    if (variant.weight != null && variant.weight !== '') {
      return String(Math.round(Number(variant.weight)));
    }
    if (variant.grams) return String(variant.grams);
    return '';
  }

  function fetchProductJs(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () {
        return null;
      });
  }

  function updateCreFormFromProduct(card, product, variant) {
    var form = card.querySelector('cre-product-form');
    if (!form || !product || !variant) return;

    var productType = String(product.type || '').toLowerCase();
    form.setAttribute('data-product-type', productType);
    form.setAttribute('data-vid', String(variant.id));
    form.setAttribute('data-track-name', product.title || '');
    form.setAttribute('data-track-id', String(product.id || ''));
    form.setAttribute('data-track-url', (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + product.handle);
    form.setAttribute('data-track-brand', product.vendor || '');

    var select = form.querySelector('.selling-plan-options');
    if (select) {
      select.innerHTML = '';
      var firstPlanId = '';

      (product.selling_plan_groups || []).forEach(function (group) {
        (group.selling_plans || []).forEach(function (plan) {
          if (!firstPlanId) firstPlanId = String(plan.id);

          var opt = document.createElement('option');
          opt.value = plan.id;
          opt.setAttribute('data-selling-plan-name', plan.name);
          opt.textContent = plan.name;
          select.appendChild(opt);
        });
      });

      if (firstPlanId) {
        select.setAttribute('data-default-selling-plan-id', firstPlanId);
      }
    }

    var button = form.querySelector('.cre-atc-btn');
    if (button) {
      if (variant.available === false) {
        button.setAttribute('disabled', '');
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
      }
    }
  }

  function applyProductJsToCard(card, product, meta) {
    if (!card || !product) return;
    meta = meta || {};

    var variant =
      (product.variants || []).find(function (v) {
        return v && v.available !== false;
      }) ||
      (product.variants || [])[0];
    if (!variant) return;

    card.id = String(variant.id);
    card.setAttribute('data-product-handle', product.handle);
    card.setAttribute('data-product-type', String(product.type || '').toLowerCase());
    if (meta.group) card.setAttribute('data-handle-group', meta.group);
    if (meta.size) card.setAttribute('data-size', meta.size);

    var titleText = String(product.title || '')
      .replace(/\[S\]/g, '')
      .replace(/\[M\]/g, '')
      .replace(/\[L\]/g, '')
      .trim();
    var titleEl = card.querySelector('.product-card__title');
    if (titleEl) {
      titleEl.textContent = titleText;
      if (titleEl.tagName === 'A') titleEl.setAttribute('href', '/products/' + product.handle);
    }

    var mediaLink = card.querySelector('.media a');
    if (mediaLink) mediaLink.setAttribute('href', '/products/' + product.handle);

    var image = variant.featured_image || product.featured_image;
    var imgEl = card.querySelector('.media img');
    if (imgEl && image) {
      var src = typeof image === 'string' ? image : image.src;
      if (src) imgEl.setAttribute('src', src);
      if (image && image.alt) imgEl.setAttribute('alt', image.alt);
    }

    var gramVal = getVariantGram(variant);
    var gramText = gramVal && gramVal !== '0' ? gramVal + ' g' : '';
    card.querySelectorAll('.product-card__gram').forEach(function (el) {
      el.textContent = gramText;
      el.classList.toggle('hidden', !gramText);
    });

    var priceHtml = formatCardMoney(variant.price);
    if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
      priceHtml +=
        ' <s class="font-grey-color font-500 font_12 price-item price-item--regular price--compare-at-price-strike-off">' +
        formatCardMoney(variant.compare_at_price) +
        '</s>';
    }
    var syncPrice = card.querySelector('.sync-price');
    if (syncPrice) syncPrice.innerHTML = priceHtml;

    var priceSync = card.querySelector('cre-price-sync');
    if (priceSync) priceSync.setAttribute('data-vid', String(variant.id));

    card.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.value = String(variant.id);
    });

    var form = card.querySelector('cre-product-form');
    if (form) {
      form.setAttribute('data-vid', String(variant.id));
      if ('productVariantId' in form) form.productVariantId = String(variant.id);
    }

    var qty = card.querySelector('cre-quantity-sync');
    if (qty) {
      qty.setAttribute('data-vid', String(variant.id));
      if ('productVariantId' in qty) qty.productVariantId = String(variant.id);
    }

    updateCreFormFromProduct(card, product, variant);

    var cartQtysElem = card.querySelector('.js-variant-cart-qtys');
    if (cartQtysElem) {
      var vid = String(variant.id);
      var qtys = {};

      try {
        qtys = JSON.parse(cartQtysElem.getAttribute('data-qtys') || '{}');
      } catch (error) {
        qtys = {};
      }

      cartQtysElem.setAttribute('data-qtys', JSON.stringify({ [vid]: +(qtys[vid] || 0) }));
    }

    if (window.reinitializeCreCartControls) {
      window.reinitializeCreCartControls(card);
    } else if (window.syncCartControlVisibility) {
      window.syncCartControlVisibility(card);
    }
  }

  function fetchCardForHandle(handle, view) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=' + encodeURIComponent(view))
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('marmeto-product-card');
        if (!card) {
          var item = doc.querySelector('.grid__item');
          if (item) card = item.querySelector('marmeto-product-card');
        }
        return card;
      })
      .catch(function () {
        return null;
      });
  }

  function mergeCardContent(targetCard, sourceCard) {
    if (!targetCard || !sourceCard) return;

    if (sourceCard.id) targetCard.id = sourceCard.id;

    ['data-product-handle', 'data-product-type', 'data-size', 'data-handle-group', 'data-sectionId', 'data-header-filter'].forEach(
      function (attr) {
        var val = sourceCard.getAttribute(attr);
        if (val != null) targetCard.setAttribute(attr, val);
      }
    );

    var srcTitle = sourceCard.querySelector('.product-card__title');
    var tgtTitle = targetCard.querySelector('.product-card__title');
    if (srcTitle && tgtTitle) {
      tgtTitle.textContent = srcTitle.textContent;
      if (srcTitle.getAttribute('href')) tgtTitle.setAttribute('href', srcTitle.getAttribute('href'));
    }

    var srcImg = sourceCard.querySelector('.media img');
    var tgtImg = targetCard.querySelector('.media img');
    if (srcImg && tgtImg) {
      ['src', 'srcset', 'alt', 'width', 'height'].forEach(function (attr) {
        var val = srcImg.getAttribute(attr);
        if (val != null) tgtImg.setAttribute(attr, val);
      });
    }

    var srcComb = sourceCard.querySelector('.ration-price-comb');
    var tgtComb = targetCard.querySelector('.ration-price-comb');
    if (srcComb && tgtComb) {
      var srcPrice = srcComb.querySelector('.sync-price');
      var tgtPrice = tgtComb.querySelector('.sync-price');
      if (srcPrice && tgtPrice) tgtPrice.innerHTML = srcPrice.innerHTML;

      var srcGram = srcComb.querySelector('.product-card__gram, .card-weight-inline');
      var tgtGram = tgtComb.querySelector('.product-card__gram, .card-weight-inline');
      if (srcGram && tgtGram) {
        tgtGram.textContent = srcGram.textContent;
        tgtGram.className = srcGram.className;
      }
    }

    var srcPriceSync = sourceCard.querySelector('cre-price-sync');
    var tgtPriceSync = targetCard.querySelector('cre-price-sync');
    if (srcPriceSync && tgtPriceSync) {
      ['data-vid', 'data-quantity', 'data-percent', 'data-section-id', 'data-current-page', 'data-collection'].forEach(
        function (attr) {
          var val = srcPriceSync.getAttribute(attr);
          if (val != null) tgtPriceSync.setAttribute(attr, val);
        }
      );
    }

    var srcMeta = sourceCard.querySelector('.mm-card__meta');
    var tgtMeta = targetCard.querySelector('.mm-card__meta');
    if (srcMeta && tgtMeta) tgtMeta.innerHTML = srcMeta.innerHTML;

    var srcNutrition = sourceCard.querySelector('.mm-card__nutrition');
    var tgtNutrition = targetCard.querySelector('.mm-card__nutrition');
    if (srcNutrition && tgtNutrition) tgtNutrition.innerHTML = srcNutrition.innerHTML;

    var srcDesc = sourceCard.querySelector('.product-card__desc');
    var tgtDesc = targetCard.querySelector('.product-card__desc');
    if (srcDesc && tgtDesc) tgtDesc.textContent = srcDesc.textContent;

    var srcQtys = sourceCard.querySelector('.js-variant-cart-qtys');
    var tgtQtys = targetCard.querySelector('.js-variant-cart-qtys');
    if (srcQtys && tgtQtys) {
      tgtQtys.setAttribute('data-qtys', srcQtys.getAttribute('data-qtys') || '{}');
    }

    var srcVariantId = sourceCard.querySelector('input[name="id"]');
    targetCard.querySelectorAll('input[name="id"]').forEach(function (input) {
      if (srcVariantId) input.value = srcVariantId.value;
    });
  }

  function ensurePanelCardContent(grid, host, group, size) {
    var entry = catalogEntriesForGroup(group).find(function (row) {
      return row.size === size;
    });
    if (!entry || !host) return Promise.resolve();

    var panel = findPanel(host, size);
    if (!panel) return Promise.resolve();

    var card = panel.querySelector('marmeto-product-card');
    if (!card || !shouldSwapCard(card, entry, size)) return Promise.resolve();

    return fetchProductJs(entry.handle).then(function (product) {
      card = panel.querySelector('marmeto-product-card');
      if (!card || !product) return;
      applyProductJsToCard(card, product, { size: size, group: group });
    });
  }

  function panelMatchesLayout(panel, layout) {
    if (!panel) return true;
    var hasCollectionUi = !!(
      panel.querySelector('.mm-card__nutrition') ||
      panel.querySelector('.product-card__desc') ||
      panel.querySelector('.mm-card__meta')
    );
    if (layout === 'collection') return hasCollectionUi;
    return !hasCollectionUi;
  }

  function injectSiblingCard(grid, group, entry) {
    if (!isHandleTaggedGroup(group)) return Promise.resolve(null);
    if (!grid || !entry || !entry.handle) return Promise.resolve(null);

    var host = ensureHostForGroup(grid, group);
    var expectedLayout = getGridCardLayout(grid, host);
    if (host && findPanel(host, entry.size)) {
      var cachedPanel = findPanel(host, entry.size);
      if (panelMatchesLayout(cachedPanel, expectedLayout)) {
        return Promise.resolve(cachedPanel);
      }
      cachedPanel.remove();
    }

    var key = group + ':' + entry.handle;
    if (injecting[key]) return injecting[key];

    var gridItemView = getGridItemView(grid, host);

    injecting[key] = fetch('/products/' + encodeURIComponent(entry.handle) + '?view=' + encodeURIComponent(gridItemView))
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var item = doc.querySelector('.grid__item[data-handle-group^="handle_"]') || doc.querySelector('.grid__item');
        if (!item) return null;

        item.setAttribute('data-handle-group', group);
        item.setAttribute('data-size', entry.size);

        host = ensureHostForGroup(grid, group);
        if (!host) {
          item.classList.add('collection-size-host');
          grid.appendChild(item);
          getOrCreatePanels(item);
          return findPanel(item, entry.size);
        }

        moveItemIntoHost(host, item);
        panel = findPanel(host, entry.size);
        card = panel && panel.querySelector('marmeto-product-card');
        if (card) {
          return fetchProductJs(entry.handle).then(function (product) {
            if (product) applyProductJsToCard(card, product, { size: entry.size, group: group });
            return panel;
          });
        }
        return panel;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        delete injecting[key];
      });

    return injecting[key];
  }

  function consolidateSimpleGrid(grid, affectedGroups) {
    var groups = affectedGroups;
    if (!groups) {
      groups = getHandleTaggedGroups(grid);
    }
    groups = groups.filter(isHandleTaggedGroup);

    groups.forEach(function (group) {
      var catalogEntries = catalogEntriesForGroup(group);
      var sizes = activeSizesFromEntries(catalogEntries);

      Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid__item')).forEach(function (li) {
        unwrapPanelHost(li);
        syncHostMetadata(li);
        if (li.getAttribute('data-handle-group') !== group) return;

        var cardSizes = sizes.length ? sizes : sizesForGroup(group, li);
        var activeSize =
          li.getAttribute('data-active-size') || li.getAttribute('data-size') || cardSizes[0] || 'medium';
        if (cardSizes.indexOf(activeSize) === -1) activeSize = cardSizes[0] || activeSize;
        if (cardSizes.length >= 1) {
          ensureSwatches(li, cardSizes, activeSize, catalogEntries);
        }
      });
    });
  }

  function replaceCartControls(card, sourceCard) {
    if (!card || !sourceCard) return;

    ['cre-product-form', 'cre-quantity-sync'].forEach(function (selector) {
      var src = sourceCard.querySelector(selector);
      var tgt = card.querySelector(selector);
      if (!src || !tgt) return;

      var adopted = document.importNode(src, true);
      tgt.replaceWith(adopted);
    });

    if (window.reinitializeCreCartControls) {
      window.reinitializeCreCartControls(card);
    }
  }

  function setGroupActiveSizeSimple(grid, host, group, size) {
    if (!host || !isHandleTaggedGroup(group)) return Promise.resolve();

    host = unwrapPanelHost(syncHostMetadata(host));
    var card = host.querySelector('marmeto-product-card');
    if (!card) return Promise.resolve();

    syncSwatchActiveState(host, size);

    return loadCatalog().then(function () {
      var catalogEntries = catalogEntriesForGroup(group);
      var sizes = activeSizesFromEntries(catalogEntries);

      if (!sizes.length) return;

      if (sizes.indexOf(size) === -1) size = sizes[0];

      var entry = catalogEntries.find(function (row) {
        return row.size === size;
      });
      if (!entry) return;

      var key = 'simple:' + group + ':' + entry.handle;
      if (injecting[key]) return injecting[key];

      var cardView = getGridItemView(grid, host);

      injecting[key] = fetchCardForHandle(entry.handle, cardView)
        .then(function (sourceCard) {
          card = host.querySelector('marmeto-product-card');
          if (!card) return;

          if (sourceCard) {
            mergeCardContent(card, sourceCard);
            replaceCartControls(card, sourceCard);
          } else {
            return fetchProductJs(entry.handle).then(function (product) {
              if (!product) return;
              card = host.querySelector('marmeto-product-card');
              if (!card) return;
              applyProductJsToCard(card, product, { size: size, group: group });
            });
          }
        })
        .then(function () {
          host.setAttribute('data-handle-group', group);
          host.setAttribute('data-size', size);
          host.setAttribute('data-active-size', size);
          ensureSwatches(host, sizes, size, catalogEntries);
          syncSwatchActiveState(host, size);

          card = host.querySelector('marmeto-product-card');
          if (card) {
            if (window.syncCartControlVisibility) {
              window.syncCartControlVisibility(card);
            } else if (window.reinitializeCreCartControls) {
              window.reinitializeCreCartControls(card);
            }
          }
        })
        .finally(function () {
          delete injecting[key];
        });

      return injecting[key];
    });
  }

  function setGroupActiveSize(grid, group, size, clickedHost) {
    if (!isHandleTaggedGroup(group)) return Promise.resolve();

    if (!usePanelMode(grid)) {
      return setGroupActiveSizeSimple(grid, clickedHost, group, size);
    }

    return loadCatalog().then(function () {
      var host = ensureHostForGroup(grid, group);
      var catalogEntries = catalogEntriesForGroup(group);
      var sizes = sizesForGroup(group, host);

      if (!sizes.length) return Promise.resolve();
      if (sizes.indexOf(size) === -1) size = sizes[0];

      var expectedLayout = getGridCardLayout(grid, host);

      if (host && findPanel(host, size)) {
        var existingPanel = findPanel(host, size);
        if (panelMatchesLayout(existingPanel, expectedLayout)) {
          return applyGroupVisibility(grid, group, size);
        }
        existingPanel.remove();
      }

      var entry = catalogEntries.find(function (row) {
        return row.size === size;
      });
      if (!entry) return Promise.resolve();

      return injectSiblingCard(grid, group, entry).then(function (panel) {
        if (!panel) return Promise.resolve();
        return applyGroupVisibility(grid, group, size);
      });
    });
  }

  function consolidateGroup(grid, group) {
    if (!isHandleTaggedGroup(group)) return;

    var host = ensureHostForGroup(grid, group);
    if (!host) return;

    var catalogEntries = catalogEntriesForGroup(group);
    var sizes = sizesForGroup(group, host);

    if (!sizes.length) {
      host.hidden = false;
      delete activeSizeByGroup[group];
      if (catalogByGroup) {
        removeAllSizeSwatches(host);
      }
      host.querySelectorAll('.collection-size-panel').forEach(function (panel) {
        panel.hidden = false;
        panel.classList.add('is-active');
      });
      return;
    }

    if (sizes.length === 1) {
      host.hidden = false;
      var onlySize = sizes[0];
      activeSizeByGroup[group] = onlySize;
      host.setAttribute('data-active-size', onlySize);
      host.setAttribute('data-size', onlySize);
      host.querySelectorAll('.collection-size-panel').forEach(function (panel) {
        var isActive = panel.getAttribute('data-size') === onlySize;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });
      ensureSwatches(host, sizes, onlySize, catalogEntries);
      return;
    }

    var activePanel = host.querySelector('.collection-size-panel.is-active');
    var currentActive =
      activeSizeByGroup[group] ||
      host.getAttribute('data-active-size') ||
      (activePanel && activePanel.getAttribute('data-size')) ||
      sizes[0];

    applyGroupVisibility(grid, group, currentActive);
  }

  function collectAddedGridItems(node) {
    var items = [];
    if (!node || node.nodeType !== 1) return items;

    if (node.classList && node.classList.contains('grid__item')) {
      items.push(syncHostMetadata(node));
    }

    if (node.querySelectorAll) {
      node.querySelectorAll('.grid__item[data-handle-group^="handle_"]').forEach(function (item) {
        items.push(syncHostMetadata(item));
      });
      node.querySelectorAll('marmeto-product-card[data-handle-group^="handle_"]').forEach(function (card) {
        var item = card.closest('.grid__item');
        if (item) items.push(syncHostMetadata(item));
      });
    }

    return items;
  }

  function consolidateIncremental(grid, addedNodes) {
    if (!grid || !addedNodes || !addedNodes.length) return Promise.resolve();

    var run = function () {
      var affectedGroups = {};
      var newItems = [];

      addedNodes.forEach(function (node) {
        collectAddedGridItems(node).forEach(function (item) {
          newItems.push(item);
          var group = item.getAttribute('data-handle-group');
          if (isHandleTaggedGroup(group)) affectedGroups[group] = true;
        });
      });

      if (newItems.length) stripStraySizeUi(grid, newItems);

      var groups = Object.keys(affectedGroups);
      if (!groups.length) return;

      if (!usePanelMode(grid)) {
        consolidateSimpleGrid(grid, groups);
        grid.classList.add('is-size-ready');
        return;
      }

      groups.forEach(function (group) {
        consolidateGroup(grid, group);
      });
      grid.classList.add('is-size-ready');
    };

    if (catalogByGroup) {
      run();
      return Promise.resolve();
    }

    return loadCatalog().then(run);
  }

  function onProductsLoaded(event) {
    var detail = (event && event.detail) || {};
    var grid = detail.grid || document.querySelector('#product-grid');
    var addedNodes = detail.addedNodes || [];

    if (!grid || !grid.dataset.sizeSwatchesInit || !addedNodes.length) return;
    scheduleConsolidateIncremental(grid, addedNodes);
  }

  function scheduleConsolidateIncremental(grid, addedNodes) {
    if (!grid || !addedNodes || !addedNodes.length) return;

    var pending = grid.__sizePendingNodes || [];
    grid.__sizePendingNodes = pending.concat(addedNodes);

    if (grid.dataset.consolidateScheduled === 'true') return;
    grid.dataset.consolidateScheduled = 'true';

    requestAnimationFrame(function () {
      var nodes = grid.__sizePendingNodes || [];
      delete grid.__sizePendingNodes;
      delete grid.dataset.consolidateScheduled;
      consolidateIncremental(grid, nodes);
    });
  }

  function consolidate(grid, affectedGroups) {
    if (!grid) return;

    stripStraySizeUi(grid);

    if (!usePanelMode(grid)) {
      consolidateSimpleGrid(grid, affectedGroups);
      grid.classList.add('is-size-ready');
      return;
    }

    var groups = affectedGroups;
    if (!groups) {
      groups = getHandleTaggedGroups(grid);
    }

    groups = groups.filter(isHandleTaggedGroup);

    groups.forEach(function (group) {
      consolidateGroup(grid, group);
    });

    grid.classList.add('is-size-ready');
  }

  function refreshAllHosts(grid) {
    if (!grid) return;
    if (!usePanelMode(grid)) {
      consolidateSimpleGrid(grid);
      grid.classList.add('is-size-ready');
      return;
    }
    var groups = [];
    grid.querySelectorAll(':scope > .grid__item.collection-size-host[data-handle-group^="handle_"]').forEach(function (host) {
      var group = host.getAttribute('data-handle-group');
      if (isHandleTaggedGroup(group)) groups.push(group);
    });
    consolidate(grid, groups);
  }

  function onClick(event) {
    var swatch = event.target.closest('.js-collection-size-swatch');
    if (!swatch) return;

    var host = resolveHost(swatch);
    var grid = getGridForElement(host);
    if (!host || !grid || !grid.contains(host)) return;

    var group = getHostGroup(host);
    if (!group) return;

    var size = swatch.getAttribute('data-size');
    if (!size) return;

    if (swatch.classList.contains('is-active')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    syncSwatchActiveState(host, size);

    var scope = getSwatchScope(host);
    if (scope) {
      scope.querySelectorAll('.js-collection-size-swatch').forEach(function (btn) {
        btn.classList.add('is-loading');
        btn.setAttribute('disabled', '');
        btn.setAttribute('aria-disabled', 'true');
      });
    }

    setCardCartControlsLoading(host, true);

    setGroupActiveSize(grid, group, size, host).finally(function () {
      setCardCartControlsLoading(host, false);

      var loadingScope = getSwatchScope(host);
      if (!loadingScope) return;
      loadingScope.querySelectorAll('.js-collection-size-swatch').forEach(function (btn) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
      });
    });
  }

  function initObserver(grid) {
    if (!grid || grid.dataset.sizeObserverBound === 'true') return;
    grid.dataset.sizeObserverBound = 'true';

    var timer = null;
    var observer = new MutationObserver(function (mutations) {
      var affectedGroups = {};
      var shouldRun = false;

      mutations.forEach(function (mutation) {
        Array.prototype.slice.call(mutation.addedNodes).forEach(function (node) {
          if (node.nodeType !== 1) return;

          var items = [];
          if (
            node.classList &&
            node.classList.contains('grid__item') &&
            node.hasAttribute('data-handle-group') &&
            isHandleTaggedGroup(node.getAttribute('data-handle-group'))
          ) {
            items.push(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.grid__item[data-handle-group^="handle_"]').forEach(function (item) {
              items.push(item);
            });
            node.querySelectorAll('marmeto-product-card[data-handle-group^="handle_"]').forEach(function (card) {
              var item = card.closest('.grid__item');
              if (item) items.push(syncHostMetadata(item));
            });
          }

          items.forEach(function (item) {
            var group = item.getAttribute('data-handle-group');
            if (!isHandleTaggedGroup(group)) return;
            shouldRun = true;
            affectedGroups[group] = true;
          });
        });
      });

      if (!shouldRun) return;

      clearTimeout(timer);
      timer = setTimeout(function () {
        var addedNodes = [];
        mutations.forEach(function (mutation) {
          Array.prototype.slice.call(mutation.addedNodes).forEach(function (node) {
            addedNodes.push(node);
          });
        });
        if (addedNodes.length) {
          scheduleConsolidateIncremental(grid, addedNodes);
        }
      }, 0);
    });

    observer.observe(grid, { childList: true });
  }

  function gridHasSizeProducts(grid) {
    if (!grid) return false;
    return !!grid.querySelector('[data-handle-group^="handle_"], marmeto-product-card[data-handle-group^="handle_"]');
  }

  function initGrid(grid) {
    if (!grid || grid.dataset.sizeSwatchesInit === 'true') return;
    if (!gridHasSizeProducts(grid)) return;

    grid.dataset.sizeSwatchesInit = 'true';
    stripStraySizeUi(grid);
    initObserver(grid);

    if (!usePanelMode(grid)) {
      grid.classList.add('is-size-ready');
    }

    loadCatalog().then(function () {
      consolidate(grid);
    });
  }

  function initAll(root) {
    getGrids(root).forEach(initGrid);
  }

  function init() {
    initAll();

    if (!cartUpdateBound && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      cartUpdateBound = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(function () {
          getGrids().forEach(refreshAllHosts);
          if (window.syncAllCartControlVisibility) {
            window.syncAllCartControlVisibility();
          }
        }, 150);
      });
    }

    var docObserver = new MutationObserver(function () {
      clearTimeout(docObserverTimer);
      docObserverTimer = setTimeout(function () {
        initAll();
      }, 100);
    });
    docObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('collection:products-loaded', onProductsLoaded);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
